import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils.js';

/**
 * The Nooly wordmark. It is a picture, so it carries the product's name as its alt text: a
 * screen reader still hears "Nooly" where a sighted person reads the logo.
 *
 * `tone="light"` is for surfaces that are always dark (the top bar). The default follows the
 * theme — the dark-green ink on a light page, the cream one once `.dark` is on.
 */
export function BrandLogo({
  tone = 'auto',
  className,
}: {
  tone?: 'auto' | 'light';
  className?: string;
}): ReactElement {
  const { t } = useTranslation();
  const size = cn('h-7 w-auto', className);

  if (tone === 'light') {
    return <img src="/brand/nooly-wordmark-light.png" alt={t('app.name')} className={size} />;
  }
  return (
    <>
      <img
        src="/brand/nooly-wordmark.png"
        alt={t('app.name')}
        className={cn(size, 'dark:hidden')}
      />
      <img
        src="/brand/nooly-wordmark-light.png"
        alt={t('app.name')}
        className={cn(size, 'hidden dark:block')}
      />
    </>
  );
}
